import React from "react";
import { ButtonV2 } from "../../ButtonV2";
import { Heading } from "../../Heading";
export const CreateAccount = ({ secondTitle = "Create a free account today", buttonLabel = "Trade now", buttonHref = "www.google.com" }) => (React.createElement("div", { className: "create-account" },
    React.createElement(Heading, { design: "h4-bold" }, secondTitle),
    React.createElement(ButtonV2, { href: buttonHref, design: "cta-large-wbg" }, buttonLabel)));
